import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Slider } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const CustomSlider = styled(Slider)`
  .ant-slider-mark-text {
    font-size: ${font.size.sm};
  }
`

const SliderWrapper = styled.div`
  padding: 0 20px 5px;
`

const Year = props => {
  const [currentValues, setCurrentValues] = useState([])
  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { putIntoServiceMin, putIntoServiceMax } = filters
  const yearsList = filtersDatas.years
  const marks = {}

  const maxValue = currentValues[1]
  const minValue = currentValues[0]

  marks[maxValue] = maxValue
  marks[minValue] = minValue

  const onChange = value => {
    setCurrentValues(value)
  }

  const handleOnChangeFiltre = item => {
    const [min, max] = item

    const extendedFiltersValues = {
      ...filters,
      putIntoServiceMax: max,
      putIntoServiceMin: min
    }

    onChangeFilter(extendedFiltersValues)
  }

  useEffect(() => {
    const values = []
    if (yearsList) {
      const maxVal = putIntoServiceMax || yearsList.max
      const minVal = putIntoServiceMin || yearsList.min

      values[0] = minVal
      values[1] = maxVal
    }
    setCurrentValues(values)
  }, [])

  return (
    <div data-test="component-stock-vehicles-list-filters-year">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-year-title'
        })}
        data-test="stock-vehicles-list-filters-year-title"
      />
      <SliderWrapper>
        {yearsList && (
          <CustomSlider
            defaultValue={currentValues}
            max={yearsList.max}
            min={yearsList.min}
            step={yearsList.step}
            range
            marks={marks}
            onAfterChange={value => handleOnChangeFiltre(value)}
            onChange={value => onChange(value)}
            tooltipVisible={false}
            data-test="stock-vehicles-list-filters-year-slider"
          />
        )}
      </SliderWrapper>
    </div>
  )
}

Year.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Year)
